"use client";

import { usePathname } from "next/navigation";
import "@/app/globals.css";
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CssBaseline from '@mui/material/CssBaseline';
import {lightTheme} from '@/theme/theme';
import React from 'react';
import NavBar from "./NavBar";
import Frequentlyaskedquestions from "./Frequentlyaskedquestions";
import Footer from "./Footer";
import Focus from "./Focus";

export default function ClientLayout({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();
    const isDashboard = pathname.startsWith("/dashboard");

    // For dashboard, include MUI providers
    if (isDashboard) {
        return (
            <ThemeProvider theme={lightTheme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <CssBaseline />
                    {children}
                </LocalizationProvider>
            </ThemeProvider>
        );
    }

    // For public pages, use lightweight layout without MUI
    return (
        <>
            <NavBar />
            {children}
            <Frequentlyaskedquestions />
            <Focus />
            <Footer />
        </>
    );
}